import React from 'react';

const Ec2ExSidebarButton = ({header, toggleColumnVisibility}) => {

  const handleClick = () => {
    toggleColumnVisibility(header.title);
  };

  return (
    <button onClick={handleClick} className={`Hidden${header.hidden}`} key={header.title}>{header.title}</button>
  );

};

export default Ec2ExSidebarButton;


// WEBPACK FOOTER //
// ./src/components/content/ec2Explorer/ec2ExSidebar/ec2ExSidebarButton/ec2ExSidebarButton.js